/*
 * @Description: chart工具
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-27 14:24:02
 * @LastEditTime: 2019-02-27 14:30:27
 */

import moment from 'moment';

const createSubtext = query => (`数据来源：数字品牌榜\n\n时间窗口：${moment(query.startDate).format('YYYY.MM.DD')} - ${moment(query.statisDate).format('YYYY.MM.DD')}`);

export {
  createSubtext
}


// WEBPACK FOOTER //
// src/chart/public.js